import { assertUserDevice } from './useragent'
import { isViewport } from './viewport'

export { assertUserDevice, isViewport }
